import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Tier, TieredRestaurant } from '../models';

@Injectable()
export class TiersService {
  private apiUrl: string = environment.apiUrl + '/pricetiers';

  constructor(private httpClient: HttpClient) {}

  getTier(tierId: string): Observable<Tier> {
    return this.httpClient.get<Tier>(`${this.apiUrl}/${tierId}`);
  }

  getTiers(): Observable<Tier[]> {
    return this.httpClient.get<Tier[]>(`${this.apiUrl}`);
  }

  createTier(tierName: string) {
    return this.httpClient.post<Tier>(`${this.apiUrl}`, { name: tierName });
  }

  removeTier(oldTierId: string, newTierId: string | null) {
    const url = newTierId
      ? `${this.apiUrl}/${oldTierId}/${newTierId}`
      : `${this.apiUrl}/${oldTierId}`;
    return this.httpClient.delete(url);
  }

  updateTier(tier: Tier) {
    this.handleDocumentTypesForSubmit(tier);

    return this.httpClient.put(`${this.apiUrl}/${tier.id}`, tier);
  }

  updateTierConfiguration(priceTierId: string, tier: Tier, updateAll = false) {
    this.handleDocumentTypesForSubmit(tier);

    return this.httpClient.put(
      `${this.apiUrl}/${priceTierId}/configuration?updateAll=${updateAll}`,
      tier,
    );
  }

  private handleDocumentTypesForSubmit(tier: Tier) {
    if (
      tier.priceTierDocument == null ||
      tier.priceTierDocument.configurations == null
    )
      return;

    var recursiveHandle = (config: any) => {
      if (config.type == 'numeric') config.value = config.value.toString();

      if (config.type == 'toggle') config.value = config.value.toString();

      if (config.children) {
        config.children.forEach((child: any) => recursiveHandle(child));
      }
    };

    tier.priceTierDocument.configurations.forEach((config) => {
      recursiveHandle(config);
    });

    return tier;
  }

  handleDocumentTypesForInput(tier: Tier) {
    if (tier.priceTierDocument == null) {
      tier.priceTierDocument = {
        configurations: [],
      };
    }

    var recursiveHandle = (config: any) => {
      if (config.type == 'numeric') config.value = +config.value;

      if (config.type == 'toggle')
        config.value = String(config.value).toLowerCase() === 'true';

      if (config.children) {
        config.children.forEach((child: any) => recursiveHandle(child));
      }
    };

    tier.priceTierDocument.configurations?.forEach((config) => {
      recursiveHandle(config);
    });

    return tier;
  }

  unlockTier(tierId: string) {
    return this.httpClient.get(`${this.apiUrl}/unlock?tierId=${tierId}`);
  }

  syncTier(tierId: string) {
    return this.httpClient.get(`${this.apiUrl}/sync?tierId=${tierId}`);
  }
}
